import type {
  CaseLevel1Option,
  CaseLevel2Option,
} from 'shared/models/common-cases';
import type { CaseMenuOption } from 'components/controls/case-menu';

export default function caseLevelsAdapter<
  T extends CaseLevel1Option | CaseLevel2Option
>(
  caseLevels: T[],
  enhancer?: (caseLevel: T) => {
    children: CaseMenuOption[];
    action?: () => void;
  }
): CaseMenuOption[] {
  return caseLevels.map((caseLevel) => {
    const base = {
      id: caseLevel.Value,
      label: caseLevel.Label,
    };

    return enhancer ? { ...base, ...enhancer(caseLevel) } : base;
  });
}
